import { render, staticRenderFns } from "./infoDetailOther.vue?vue&type=template&id=2c404292&scoped=true"
import script from "./infoDetailOther.vue?vue&type=script&lang=js"
export * from "./infoDetailOther.vue?vue&type=script&lang=js"
import style0 from "./infoDetailOther.vue?vue&type=style&index=0&id=2c404292&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c404292",
  null
  
)

export default component.exports